<template>
  <div class="information-cont">
    <div id="entryInformation">
      <div class="con-center">
        <div class="title">
          <span>参赛须知</span>
        </div>
        <!--活动说明-->
        <div class="main-cont description">
          <div class="main-title des-title">
            <span>活动说明</span>
          </div>
          <div class="main-text">1、参赛者需下载
            <a class="line" target="_self" @click="downloadFile">
              【赛事资料】
            </a>
<!--            <i class="line" @click="download">【赛事资料】</i>-->
            ，围绕命题
            <i>“DELL Precision 2047号飞船”</i>
            进行
            <span>3D模型</span>
            设计创作。
          </div>
          <div class="main-text">2、主体：飞船的颜色、质感、细节设定均向参赛者开放，使用的创作软件不限，参赛者可自由发挥，并在创作过程中，
            <span>将</span>
            <a class="line" target="_self" @click="downloadFile">
              【赛事资料】
            </a>
<!--            <i class="line" @click="download">【赛事资料】</i>-->
            <span>中所描述的DELL Precision工作站产品特点（高效率“例：动力”、扩展性“例：更多的可扩展”、专业性“例：科技感及创意性”等任一特点）在飞船上进行体现。</span>
            <i>作品中的飞船主体须带有“DELL Precision 2047”字样。</i>
          </div>
          <div class="main-text">3、场景：对创作的飞船3D设计进行与之相匹配的场景图创造。</div>
          <div class="main-text">4、作品上传提交时，需附上设计思路或创意说明的文字简述。</div>
          <div class="submission">
            <span>5、提交内容:</span>
            <ul class="main-text-info">
              <li>a：DELL Precision 2047号飞船在对应场景中的<span>完整3D作品一张</span></li>
              <li>b：DELL Precision 2047号飞船的<span>正面图、侧面图、顶视图各一张</span></li>
              <li>c：<span>200字以内的设计思路简要说明</span></li>
            </ul>
          </div>
          <div class="main-text">6、 请保留作品源文件，主办方会根据需求与获奖者联系推进后续平台使用、修改完善等相关事宜。
            <span>参赛作品源文件需保留</span>
            <i>300dpi</i>
            <span>分辨率，作品推荐尺寸</span>
            <i>640mm*360mm</i>
            <span>，可用于媒体传播及印刷生产的源文件。其中，作品色彩为</span>
            <i>RGB</i>
            <span>模式，作品出图为</span>
            <i>JPG</i>
            <span>格式。</span>
          </div>
        </div>

        <!--参与方式-->
        <div class="main-cont participation pc">
          <div class="main-title par-title">
            <span>参与方式</span>
          </div>
          <ul class="par-con">
            <li v-for="(par,index) in parCon">
              <span>{{ index+1 }}</span>
              {{par}}
            </li>
          </ul>
        </div>
        <div class="main-cont participation mobeli">
          <div class="main-title par-title">
            <span>参与方式</span>
          </div>
          <ul class="par-con">
            <li>
              <span>1</span>
              <p>详细查看活动说明，在线填写报名资料，下载</p>
              <p>赛事资料包，根据要求进行创作；</p>
            </li>
            <li>
              <span>2</span>
              <p>将创作完成的作品电子版上传到官方活动网站，</p>
              <p>同时填写作品的创意阐述；</p>
            </li>
            <li>
              <span>3</span>
              <p>将自己的参赛作品链接分享给好友，进行拉票，</p>
              <p>投票好友既有机会获得精美礼品一份；</p>
            </li>
            <li>
              <span>4</span>
              <p>静候结果揭晓，获奖者将得到排名所对应的奖励，</p>
              <p>并受邀出席DELL Precision 25周年盛典。</p>
            </li>
          </ul>
        </div>

        <!--评选标准-->
        <div class="main-cont standard">
          <div class="main-title sta-title">
            <span>评选标准</span>
          </div>
        </div>
        <div class="main-cont">
          <div class="sta-con pc">
            <div class="sta-con-bg" v-for="(sta) in staCon">
              <p class="sta-con-title">{{ sta.title }}</p>
              <p class="sta-con-info">{{sta.text}}</p>
            </div>
          </div>
          <div class="sta-con mobeli">
            <div class="sta-con-flex">
              <div class="sta-con-bg" v-for="(sta, index) in staCon" v-if="index <= 1">
                <p class="sta-con-title">{{ sta.title }}</p>
                <p class="sta-con-info">{{sta.text}}</p>
              </div>
            </div>
            <div class="sta-con-flex">
              <div class="sta-con-bg" v-for="(sta, index) in staCon" v-if="index >= 2">
                <p class="sta-con-title">{{ sta.title }}</p>
                <p class="sta-con-info">{{sta.text}}</p>
              </div>
            </div>

          </div>
        </div>

        <!--作品评选-->
        <div class="main-cont selection">
          <div class="main-title sel-title">
            <span>作品评选</span>
          </div>
          <ul class="sel-con">
            <li>1、初筛环节由品牌方进行筛选，审核通过的参赛作品方可进行展示；</li>
            <li>2、第二轮评选以线下评委会的方式进行，由评委讨论评选出金奖、银奖及铜奖；</li>
            <li>3、最佳人气奖将由点赞最高的前5部作品获得；</li>
            <li>4、助力达人奖将随机从点赞用户中进行抽取。</li>
          </ul>
        </div>

        <!--相关权益-->
        <div class="main-cont selection">
          <div class="main-title equity-title">
            <span>相关权益</span>
          </div>
          <ul class="sel-con">
            <li>1、金奖（1名）、银奖（2名），作品的完整版权将转让至主办方（或其指定的公司）， 铜奖（5名）作品的 2 年传播权将转让至主办方（或其指定的公司），获奖作者需协助签署《著作权转让协议》。主办方享有对相应设计方案进行再设计、生产、销售、展示、出版等全部权益，获奖作者不得将此权利再次授权任何其他个人或机构，获奖作者保留对其作品的永久署名权；</li>
            <li>2、 若主办方需对金奖、银奖、铜奖作品进行进一步完善或开发、设计周边产品，获奖作者需协助配合（有偿）；</li>
            <li>3、 主办单位拥有对全部参赛作品进行展示、报道、宣传的权利，参赛作者保留对其作品的署名权。主办方如需对获奖作品外的作品进行开发、生产、销售等商业用途，需取得参赛作者书面许可，并向参赛作者支付相应设计费用；</li>
            <li>4、 作品一经提交，将视为参赛作者同意并遵守比赛相关规定，若作品在商业使用中其著作权存在争议，主办单位不承担因作品侵犯他人（或单位）的权利而产生的法律责任，由提供作品的参赛作者承担全部法律责任；</li>
            <li>5、 如果获奖作者放弃履行相关版权转让或授权义务，则视为主动放弃相应奖项；</li>
            <li>6、 主办方对本活动保留最终解释权。</li>
          </ul>
        </div>

      </div>
    </div>
    <div id="downloadMaterials" >
      <div class="main-button">
        <a  target="_self" @click="downloadFile" >
          下载赛事资料
        </a>
      </div>

      <div class="download-desc">
        若对本次创意大赛有任何疑问，可通过以下方式联系我们：<a href="mailto:Precision2047@juxt.cn">Precision2047@juxt.cn</a>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "EntryInformation",
  data() {
    return{
      parCon: ['详细查看活动说明，在线填写报名资料，下载赛事资料包，根据要求进行创作；' ,
        '将创作完成的作品电子版上传到官方活动网站，同时填写作品的创意阐述；',
        '将自己的参赛作品链接分享给好友，进行拉票，投票好友既有机会获得精美礼品一份；',
        '静候结果揭晓，获奖者将得到排名所对应的奖励，并受邀出席DELL Precision 25周年盛典。'
      ],
      staCon: [
        {title: '品牌相关', text: '作品中的飞船主体须带有“DELL Precision 2047”字样，须将Precision特点在飞船设计中进行体现。'},
        {title: '创意独特', text: '作品视角独特，3D技术精湛，并符合国家相关法律法规，完全原创，无抄袭行为。'},
        {title: '作品完整', text: '作品中的飞船主体及场景画面具有较高的完整性、辨识度、科技感，整体色彩和谐、美观。'},
        {title: '延展应用', text: '作品的可延展及可应用性较强，品牌可顺利进行二次创作与其他延展应用。'}
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.information-cont{
  padding-bottom: 130px;
  #entryInformation{
    position: relative;
    width: 100%;
    .con-center{
      //max-width: 1160px;
      margin: 0 auto;
      position: relative;
      //padding: 0 10%;
      .title{
        position: absolute;
        content: '';
        width: 255px;
        height: 39px;
        top: -35px;
        left: 0;
        right: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        background: url("../assets/images/entryInfo_title.png") no-repeat;
        background-size: 100% 100%;
        span{
          line-height: 82px;
          //font-size: 25px;
          color: #14456e;
          font-weight: bold;
        }
        &:after{
          position: absolute;
          content: '';
          width: 249px;
          height: 75px;
          top: 6px;
          left: 2px;
          background: url("../assets/images/entryInfo_title_bg.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .main-cont{
        width: 860px;
        margin: auto;
        //overflow: hidden;
        //font-size: 17px;
        &.description{
          padding-top: 86px;
        }
        &.participation{
          box-sizing: border-box;
          //padding-top: 66px;
        }
        &.standard{
          padding-top: 66px;
          position: relative;
        }
        .main-title{
          text-align: center;
          &.des-title{
            padding-bottom: 40px;
          }
          &.par-title{
            padding-bottom: 28px;
          }
          &.sel-title{
            padding-bottom: 30px;
          }
          &.equity-title{
            padding: 60px 0 30px 0;
          }

          span{
            text-align: center;
            //font-size: 21px;
            background: linear-gradient(to right, #729dc2, #7487b3);
            -webkit-background-clip: text;
            color: transparent;
            display: inline-block;
            font-weight: bold;
          }
        }
        .main-text{
          color: #435270;
          letter-spacing: 1px;
          i{
            font-style: normal;
            font-weight: bold;
            color: #1a6cb0;
            &.line{
              cursor: pointer;
              text-decoration: underline;
            }
          }
          a{
            font-style: normal;
            font-weight: bold;
            color: #1a6cb0;
            &.line{
              cursor: pointer;
              text-decoration: underline;
            }
          }
          span{
            color: #1a6cb0;
          }
          .main-info{
            list-style: none;
          }
        }
        .submission{
          //display: flex;
          span{
            //font-size: 17px;
            color: #435270;
            line-height: 32px;
            letter-spacing: 1px;
          }
          .main-text-info{
            padding-left: 20px;
            margin: 0;
            li{
              list-style: none;
              //font-size: 17px;
              color: #1a6cb0;
              line-height: 34px;
              span{
                font-weight: bold;
                color: #1a6cb0;
              }
            }
          }
        }
        .par-con{
          padding: 0;
          margin: 0;
          li{
            position: relative;
            //font-size: 17px;
            color: #435270;
            //line-height: 44px;
            padding-left: 60px;
            span{
              position: absolute;
              //top: 3px;
              //left: 10px;
              //width: 38px;
              //height: 38px;
              background: #fff;
              border-radius: 50%;
              text-align: center;
              //line-height: 38px;
              font-weight: bold;
              color: #14456e;
            }
          }
        }
        .sel-con{
          li{
            //font-size: 17px;
            color: #435270;
            line-height: 35px;
            list-style: none;
          }
        }
        .sta-con{
          //display: flex;
          //flex-wrap: wrap;
          //justify-content: space-around;
          width: 100%;
          margin: 28px 0 62px 0;

          .sta-con-bg{
            //width: 376px;
            //height: 179px;
            box-shadow: 5px 10px 20px rgba(0, 0, 0, .08);
            border-radius: 15px;
            margin-bottom: 28px;
            //padding: 30px 30px 0 30px;
            box-sizing: border-box;

            .sta-con-title{
              //padding-bottom: 36px;
              //font-size: 25px;
              color: #14456e;
              font-weight: bold;
            }
            .sta-con-info{
              //font-size: 15px;
              color: #14456e;
              line-height: 30px;
            }
          }
        }
      }
      .download-desc{
        font-size: 12px;
      }
    }
  }
  #downloadMaterials{
    padding-top: 60px;
    margin: auto;
    .main-button{
      text-align: center;
      //padding: 60px 0 126px 0;
      //font-size: 17px;
      cursor: pointer;
      a{
        display: inline-block;
        width: 183px;
        height: 47px;
        color: #fff;
        font-size: 17px;
        line-height: 47px;
        background: url("../assets/images/match_button.png") no-repeat;
        background-size: 100% 100%;
        text-decoration: none;
      }
    }
    .download-desc{
      margin-top: 20px;
      text-align: center;
      font-size: 18px;
      color:#435270 ;
      a{
        color:#435270;
      }
    }
  }
}

@media (min-width: 992px){
  .information-cont{
    background:  linear-gradient(
        20deg,
        #a9d4fc 0%,
        #e9f0fc 22%
    );
    #entryInformation{
      position: relative;
      &:before{
        position: absolute;
        content: '';
        right: 0;
        top: 0;
        width: 1512px;
        height: 1600px;
        background: linear-gradient(
            235deg,
            rgba(249,233,244,1) 0%,
            #e9f0fc 50%,
            rgba(233,240,252,0) 100%
        );
      }
      .con-center{
        padding: 0 10%;
        .title{
          span{
            font-size: 29px;
          }
        }
        .main-cont{
          max-width: 860px;
          font-size: 17px;
          &.description{
            &:before{
              content: '';
              position: absolute;
              top: 236px;
              right: 50px;
              width: 203px;
              height: 256px;
              background: url("../assets/images/decorate3.png") no-repeat;
              background-size: 100% 100%;
            }
          }
          &.participation{
            padding: 66px 0 0 0;
            &.mobeli{
              display: none;
            }
            &.pc{
              display: block;
            }
          }
          &.standard{
            position: relative;
            &:before{
              content: '';
              position: absolute;
              left: -144px;
              top: 147px;
              width: 101px;
              height: 93px;
              background: url("../assets/images/decorate4.png") no-repeat;
              background-size: 100% 100%;
            }
          }
          .main-text{
            font-size: 17px;
            line-height: 32px;
          }
          .submission{
            display: flex;
            span{
              font-size: 17px;
            }
            .main-text-info{
              li{
                font-size: 17px;
              }
            }
          }
          .par-con{
            padding: 0;
            li{
              font-size: 17px;
              line-height: 44px;
              span{
                top: 3px;
                left: 10px;
                width: 38px;
                height: 38px;
                line-height: 38px;
              }
            }
          }
          .sel-con{
            padding: 0;
            font-size: 17px;
          }
          .sta-con{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-around;
            &.pc{
              display: flex;
            }
            &.mobeli{
              display: none;
            }
            .sta-con-bg{
              width: 376px;
              height: 230px;
              padding: 30px 30px 0 30px;
              &:first-child{
                background: url("../assets/images/standard_bg1.png") no-repeat;
                background-size: 100% 100%;
              }
              &:nth-child(2){
                background: url("../assets/images/standard_bg2.png") no-repeat;
                background-size: 100% 100%;
              }
              &:nth-child(3){
                background: url("../assets/images/standard_bg3.png") no-repeat;
                background-size: 100% 100%;
              }
              &:nth-child(4){
                background: url("../assets/images/standard_bg4.png") no-repeat;
                background-size: 100% 100%;
              }
              .sta-con-title{
                padding-bottom: 36px;
                font-size: 25px;
              }
              .sta-con-info{
                font-size: 15px;
              }
            }
          }
        }
      }
    }
    #downloadMaterials{
      .main-button{
        font-size: 17px;
        a{
          font-weight: normal;
          text-decoration: none;
        }
      }
    }
  }
}
@media (max-width: 992px) {
  .information-cont{
    background: linear-gradient(
        43deg,
        rgba(183, 217 ,252 ,.4s)0%,
        #e9f0fc 30%,
        #e9f0fc 100%
    );

    #entryInformation{
      .con-center{
        //padding: 0 50px;
        .title{
          span{
            font-size: 29px;
          }
        }
        .main-cont{
          width: 100%;
          font-size: 24px;
          &.description{
            padding: 86px 50px 0;
            box-sizing: border-box;
          }
          &.participation{
            padding: 66px 0 0 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &.mobeli{
              display: flex;
            }
            &.pc{
              display: none;
            }
          }
          .submission{
            display: block;
            span{
              font-size: 21px;
            }
            .main-text-info{
              li{
                font-size: 21px;
              }
            }
          }
          .main-text{
            font-size: 21px;
            line-height: 38px;
          }
          .par-con{
            //padding: 0 20px;
            li{
              font-size: 21px;
              line-height: 33px;
              padding-bottom: 26px;
              span{
                top: 12px;
                left: 5px;
                width: 42px;
                height: 42px;
                line-height: 42px;
              }
            }
          }
          .sta-con{
            display: flex;
            flex-direction: column;
            //justify-content: space-evenly;
            &.pc{
              display: none;
            }
            &.mobeli{
              display: flex;
            }
            .sta-con-flex{
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-around;
              &:nth-child(1){
                .sta-con-bg {
                  &:first-child{
                    background: url("../assets/images/standard_bg1.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  &:nth-child(2){
                    background: url("../assets/images/standard_bg2.png") no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
              &:nth-child(2){
                .sta-con-bg{
                  &:nth-child(1){
                    background: url("../assets/images/standard_bg3.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  &:nth-child(2){
                    background: url("../assets/images/standard_bg4.png") no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
              .sta-con-bg{
                width: 340px;
                height: 180px;
                padding: 20px 11px 0;
                .sta-con-title{
                  padding-bottom: 26px;
                  font-size: 29px;
                }
                .sta-con-info{
                  font-size: 18px;
                  letter-spacing: normal;
                }
              }
            }

          }
          .sel-con{
            padding: 0 30px;
            font-size: 22px;
          }

        }

      }
    }
    #downloadMaterials{
      .main-button{
        font-size: 21px;
        a{
          font-weight: bold;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
